import React, { ChangeEvent, useState } from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

import { FIND_CHAT, GET_CHATS } from '../../queries';

const CREATE_CHAT = gql`
  mutation CreateChat($productId: String!, $message: String!) {
    createChat(productId: $productId, message: $message) {
      id
      chatId
      text
      author {
        id
        firstName
        lastName
        image
      }
      createdAt
    }
  }
`;

const CreateChat = props => {
  const { open, setOpen, product, productId } = props;
  const {
    name,
    imagesUrls,
    user: { firstName, lastName }
  } = product;
  const [text, updateText] = useState('');

  const sendMessage = (mutationFn: () => void) => {
    mutationFn();
    closeModal();
  };

  const closeModal = () => {
    setOpen(false);
    updateText('');
  };

  return (
    <Dialog open={open} onClose={closeModal} fullWidth>
      <DialogTitle id="form-dialog-title">{name}</DialogTitle>
      <DialogContent>
        <TextField
          placeholder="Написати повідомлення"
          fullWidth
          multiline
          rows="4"
          margin="normal"
          variant="outlined"
          value={text}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            updateText(e.target.value)
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal} color="primary">
          Закрити
        </Button>
        <Mutation
          mutation={CREATE_CHAT}
          variables={{ productId, message: text }}
          refetchQueries={[
            {
              query: FIND_CHAT,
              variables: { productId }
            }
          ]}
          update={(store, { data }) => {
            try {
              const cachedChats = store.readQuery({ query: GET_CHATS });
              const newChat = {
                id: data.createChat.chatId,
                from: `${firstName} ${lastName}`,
                product: {
                  id: productId,
                  name,
                  image: imagesUrls[0]
                },
                lastMessage: data.createChat,
                unread: 0
              };
              // @ts-ignore
              cachedChats.userChats.unshift(newChat);
              store.writeQuery({ query: GET_CHATS, data: cachedChats });
            } catch {
              // Not queried yet, ignore
            }
          }}
        >
          {(createChatMutation, { loading: isLoading }) => {
            if (isLoading) {
              return (
                <div style={{ textAlign: 'center' }}>
                  <CircularProgress />
                </div>
              );
            }

            return (
              <Button
                variant="outlined"
                onClick={() => sendMessage(createChatMutation)}
                disabled={!text.trim()}
              >
                Надіслати
              </Button>
            );
          }}
        </Mutation>
      </DialogActions>
    </Dialog>
  );
};

export default CreateChat;
